import React from 'react';
import { Window, WindowActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from 'react-bootstrap';

interface SaveConflictDialogProps {
  onReload: () => void;
  onCancel: () => void;
}

export const SaveConflictDialog: React.FC<SaveConflictDialogProps> = ({
  onReload,
  onCancel
}) => {
  return (
    <Window
      title={'Version Conflict'}
      draggable={false}
      modal={true}
      resizable={false}
      minimizeButton={undefined}
      maximizeButton={undefined}
      initialWidth={500}
      initialHeight={390}
      onClose={onCancel}>
      <div>
        <p className="text-danger fw-bold">Warning: Stale Local State</p>
        <p>
          A newer version of this game has been saved to the server by another
          session or user.
        </p>
        <p>To prevent overwriting those changes, saving has been blocked.</p>
        <p>
          Please reload the latest version from the server. Your current local
          changes will be lost if you haven't manually backed them up.
        </p>
      </div>
      <WindowActionsBar>
        <Button variant="secondary" onClick={onCancel}>
          Cancel and Review
        </Button>
        <Button variant="danger" onClick={onReload}>
          Reload Latest from Server
        </Button>
      </WindowActionsBar>
    </Window>
  );
};

export default SaveConflictDialog;
